import { FooterContent } from './FooterContent';

export const Footer = () => {
  return (
    <div role="contentinfo" className="w-screen border-t-1 border-green-forest py-2.5 px-1.5 sm:py-5 sm:px-2.5">
      <div className="flex flex-col sm:flex-row sm:gap-2 justify-center items-center">
        <FooterContent />
      </div>
    </div>
  );
};
